import { jsx as _jsx } from "react/jsx-runtime";
import { ClipType } from "@air/api/types";
import { setUploadImageLoadingAction, setUploadImagePreviewAction } from "@air/redux-uploader";
import { drawImage } from "canvas-object-fit";
import { useCallback, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { isPreviewAvailable } from "../utils";
export const UPLOAD_PREVIEW_SIZE = 400;
export const UploadPreviewLoader = (param)=>{
    let { upload, upload: { apiUploadData: { type } } } = param;
    const dispatch = useDispatch();
    const canvasRef = useRef(null);
    const loadVideoPreview = useCallback(()=>{
        const video = document.createElement("video");
        video.preload = "auto";
        const source = document.createElement("source");
        video.appendChild(source);
        const src = URL.createObjectURL(upload.file);
        source.src = src;
        source.type = "video/".concat(upload.apiUploadData.ext);
        video.addEventListener("loadeddata", ()=>{
            if (canvasRef.current) {
                const canvas = canvasRef.current;
                const ctx = canvas.getContext("2d");
                if (ctx) {
                    const videoRatio = video.videoWidth / video.videoHeight;
                    canvas.height = UPLOAD_PREVIEW_SIZE;
                    canvas.width = UPLOAD_PREVIEW_SIZE * videoRatio;
                    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
                    const url = canvas.toDataURL();
                    dispatch(setUploadImagePreviewAction({
                        uploadId: upload.id,
                        imageBase64: url
                    }));
                    URL.revokeObjectURL(src);
                }
            }
        });
        video.load();
    }, [
        dispatch,
        upload.apiUploadData.ext,
        upload.file,
        upload.id
    ]);
    // this has better performance than using getBase64
    const loadImagePreview = useCallback(()=>{
        const image = document.createElement("img");
        const src = URL.createObjectURL(upload.file);
        image.onload = function() {
            if (canvasRef.current) {
                const canvas = canvasRef.current;
                const ctx = canvas.getContext("2d");
                if (ctx) {
                    canvas.width = UPLOAD_PREVIEW_SIZE;
                    canvas.height = UPLOAD_PREVIEW_SIZE;
                    drawImage(ctx, image, 0, 0, UPLOAD_PREVIEW_SIZE, UPLOAD_PREVIEW_SIZE, {
                        objectFit: "cover"
                    });
                    dispatch(setUploadImagePreviewAction({
                        uploadId: upload.id,
                        imageBase64: canvas.toDataURL()
                    }));
                    URL.revokeObjectURL(src);
                }
            }
        };
        image.src = src;
    }, [
        dispatch,
        upload.file,
        upload.id
    ]);
    useEffect(()=>{
        if (isPreviewAvailable(upload) && !upload.imageBase64 && !upload.isImageLoading) {
            dispatch(setUploadImageLoadingAction({
                uploadId: upload.id,
                isImageLoading: true
            }));
            if (type === ClipType.video) {
                loadVideoPreview();
            } else {
                loadImagePreview();
            }
        }
    }, [
        dispatch,
        loadImagePreview,
        loadVideoPreview,
        type,
        upload,
        upload.imageBase64
    ]);
    if (upload.imageBase64 || !isPreviewAvailable(upload)) {
        return null;
    }
    return /*#__PURE__*/ _jsx("div", {
        className: "hidden overflow-hidden",
        style: {
            width: UPLOAD_PREVIEW_SIZE,
            height: UPLOAD_PREVIEW_SIZE
        },
        children: /*#__PURE__*/ _jsx("canvas", {
            ref: canvasRef
        })
    });
};
